import { UserGender } from '@/gql/graphql';
import type { Sex } from '~/types/app';

/**
 * @deprecated 新規でコードを書くならgetUserProfileStringを使ってgqlの型で書くこと
 */
export const getUserProfileStringLegacy = (
  sex: Sex,
  birthYear: Maybe<number>
): string => {
  const gender: UserGender = (() => {
    switch (sex) {
      case 'male':
        return UserGender.Male;
      case 'female':
        return UserGender.Female;
      default:
        return UserGender.NoAnswer;
    }
  })();

  return getUserProfileString(gender, birthYear);
};

export const getUserProfileString = (
  gender: UserGender,
  birthYear: number | null | undefined
): string => {
  if (!birthYear && gender === UserGender.NoAnswer) {
    return '性別・年齢未記入';
  }
  const genderString = (() => {
    switch (gender) {
      case UserGender.Male:
        return '男性';
      case UserGender.Female:
        return '女性';
      case UserGender.Other:
        return '性別その他';
      default:
        return '性別未記入';
    }
  })();

  const ageString = !birthYear
    ? '年齢未記入'
    : `${getUserAgeFromBirthYear(birthYear)}歳`;

  return `${genderString}・${ageString}`;
};

export const getUserAgeFromBirthYear = (birthYear: number) => {
  return new Date().getFullYear() - birthYear;
};
